"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actions = void 0;

var _helper = require("@/services/helper/helper.service");

var _request = require("@/services/request/request.service");

var helper = new _helper.Helper();
var actions = {
  changeLanguage: function changeLanguage(_ref, langCode) {
    var commit = _ref.commit;
    helper.setCookie(process.env.VUE_APP_LOCALE_COOKIE, langCode, helper.getDomain(), 90);
    commit('SET_LANGUAGE', langCode);
  },
  loadCoreInformation: function loadCoreInformation(_ref2) {
    var commit = _ref2.commit,
        state = _ref2.state,
        rootState = _ref2.rootState,
        dispatch = _ref2.dispatch;
    var lfToken = rootState['authentication']['lfToken'];
    var requestAuth = new _request.Request('application/json', lfToken);
    return requestAuth.getAll([requestAuth.getFullPath('LEGACY_CORE', "drivers?limit=999"), requestAuth.getFullPath('LEGACY_CORE', "projectCodes?limit=999&filter=blockedProjects"), requestAuth.getFullPath('LEGACY_CORE', "customers?limit=999"), requestAuth.getFullPath('LEGACY_CORE', "trucks?limit=999")]).then(function (data) {
      commit('SET_CORE_INFORMATION', data);
      return true;
    }).catch(function () {
      return false;
    });
  }
};
exports.actions = actions;